"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.oldLace = exports.panache = exports.whiteSmoke = exports.violetEggplant = exports.strikeMaster = exports.lavenderRose = exports.brightRed = exports.thunderBird = exports.sundown = exports.curiousBlue = exports.turquoiseBlue = exports.anakiwa = exports.tealBlue = exports.veniceBlue = exports.deepCerulean = exports.fire = exports.blazeOrange = exports.apricot = exports.limeade = exports.apple = exports.conifer = exports.pirateGold = exports.butterCup = exports.peach = exports.tarawera = exports.atoll = exports.blueLagoon = exports.bondiBlue = exports.java = exports.frenchPass = exports.paleTurquoise = exports.catskillWhite = exports.wildSand = exports.mercury = exports.gainsboro = exports.alto = exports.dustyGray = exports.boulder = exports.emperor = exports.mineShaft = exports.gravel = exports.blueWhale = exports.darkCerulean = exports.black = exports.white = void 0;

/**
 * Copied from colors.less and turned into an enumeration
 *
 */
var white = '#FFFFFF';
exports.white = white;
var black = '#000000';
exports.black = black;
var darkCerulean = '#005789';
exports.darkCerulean = darkCerulean;
var blueWhale = '#09344d';
exports.blueWhale = blueWhale;
var gravel = '#51534A'; //--Grey Spectrum--

exports.gravel = gravel;
var mineShaft = '#333333';
exports.mineShaft = mineShaft;
var emperor = '#555555';
exports.emperor = emperor;
var boulder = '#777777';
exports.boulder = boulder;
var dustyGray = '#999999';
exports.dustyGray = dustyGray;
var alto = '#CFCFCF';
exports.alto = alto;
var gainsboro = '#E3E3E3';
exports.gainsboro = gainsboro;
var mercury = '#E6E6E6';
exports.mercury = mercury;
var wildSand = '#F4F4F4'; //--Parchment Teal--

exports.wildSand = wildSand;
var catskillWhite = '#E9F3F5';
exports.catskillWhite = catskillWhite;
var paleTurquoise = '#B2F2FF';
exports.paleTurquoise = paleTurquoise;
var frenchPass = '#B2F2FF';
exports.frenchPass = frenchPass;
var java = '#1DAFCC';
exports.java = java;
var bondiBlue = '#0093B2';
exports.bondiBlue = bondiBlue;
var blueLagoon = '#067A91';
exports.blueLagoon = blueLagoon;
var atoll = '#095F70';
exports.atoll = atoll;
var tarawera = '#09414D'; //--Mustard--

exports.tarawera = tarawera;
var peach = '#FFE7B2';
exports.peach = peach;
var butterCup = '#F1AE1D'; //<-Primary

exports.butterCup = butterCup;
var pirateGold = '#B37A00'; // --Green--

exports.pirateGold = pirateGold;
var conifer = '#90E665';
exports.conifer = conifer;
var apple = '#6DBE45'; //<-Primary

exports.apple = apple;
var limeade = '#349106'; //--Orange--

exports.limeade = limeade;
var apricot = '#E69465';
exports.apricot = apricot;
var blazeOrange = '#FF5E00'; //<-Primary

exports.blazeOrange = blazeOrange;
var fire = '#B34100'; //--Dark Blue--

exports.fire = fire;
var deepCerulean = '#0071B3';
exports.deepCerulean = deepCerulean;
var veniceBlue = '#065E91'; //<-Primary

exports.veniceBlue = veniceBlue;
var tealBlue = '#094A70'; //--Light Blue--

exports.tealBlue = tealBlue;
var anakiwa = '#B2E3FF';
exports.anakiwa = anakiwa;
var turquoiseBlue = '#65B6E6'; //<-Primary

exports.turquoiseBlue = turquoiseBlue;
var curiousBlue = '#1D8CCC'; //--Red--

exports.curiousBlue = curiousBlue;
var sundown = '#FFB2B5';
exports.sundown = sundown;
var thunderBird = '#C4151C'; //<-Primary

exports.thunderBird = thunderBird;
var brightRed = '#B30006'; //--Purple--

exports.brightRed = brightRed;
var lavenderRose = '#FFB2FF';
exports.lavenderRose = lavenderRose;
var strikeMaster = '#976197'; //<-Primary

exports.strikeMaster = strikeMaster;
var violetEggplant = '#910691'; //--Validation --

exports.violetEggplant = violetEggplant;
var whiteSmoke = '#FFEDED';
exports.whiteSmoke = whiteSmoke;
var panache = '#EAF4E7';
exports.panache = panache;
var oldLace = '#FFF6E2';
exports.oldLace = oldLace;
var _default = {
  white: white,
  black: black,
  darkCerulean: darkCerulean,
  blueWhale: blueWhale,
  gravel: gravel,
  mineShaft: mineShaft,
  emperor: emperor,
  boulder: boulder,
  dustyGray: dustyGray,
  alto: alto,
  gainsboro: gainsboro,
  mercury: mercury,
  wildSand: wildSand,
  catskillWhite: catskillWhite,
  paleTurquoise: paleTurquoise,
  frenchPass: frenchPass,
  java: java,
  bondiBlue: bondiBlue,
  blueLagoon: blueLagoon,
  atoll: atoll,
  tarawera: tarawera,
  peach: peach,
  butterCup: butterCup,
  pirateGold: pirateGold,
  conifer: conifer,
  apple: apple,
  limeade: limeade,
  apricot: apricot,
  blazeOrange: blazeOrange,
  fire: fire,
  deepCerulean: deepCerulean,
  veniceBlue: veniceBlue,
  tealBlue: tealBlue,
  anakiwa: anakiwa,
  turquoiseBlue: turquoiseBlue,
  curiousBlue: curiousBlue,
  sundown: sundown,
  thunderBird: thunderBird,
  brightRed: brightRed,
  lavenderRose: lavenderRose,
  strikeMaster: strikeMaster,
  violetEggplant: violetEggplant,
  whiteSmoke: whiteSmoke,
  panache: panache,
  oldLace: oldLace
};
exports.default = _default;